import { connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { SortOptionValue } from 'src/types';
import { SortBy } from '../components/SortBy';
import {
  selectSelectedSortingOptionInSentenceCase,
  selectSortingOptionsInSentenceCase,
} from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSelectSortOption: (value: SortOptionValue) => {
    dispatch(filterMenuActions.selectSortOption(value));
    (dispatch as AppThunkDispatch)(updateFilters(UpdateFiltersActionType.SORT));
  },
});

export const mapStateToProps = (state: ReduxApplicationState) => ({
  isLoading: state.products.isLoading,
  sortingOptions: selectSortingOptionsInSentenceCase(state),
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
});

export const SortByContainer = connect(mapStateToProps, mapDispatchToProps)(SortBy);
